import React, { useState } from 'react';
import { useAppDispatch } from 'flow/hooks/useRedux';

import { updateVoicemailSettings } from 'flow/actions/voicemail-actions';
import SettingRow from 'flow/components/Setting/SettingRow';
import SettingSection from 'flow/components/Setting/SettingSection';
import InputField from 'flow/components/ui-components/InputField';
import Toggle from 'flow/components/ui-components/Toggle';
import useAppContext from 'flow/hooks/useAppContext';
import useVoicemail from 'flow/hooks/useVoicemail';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { isEmptyNullOrUndefined } from 'flow/utils';

interface Props {
    extensionKey: ExtensionKey;
}

const EditVoicemailLogin = ({ extensionKey }: Props) => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const { voicemailSettings } = useVoicemail(extensionKey);

    const [editRequireLogin, setEditRequireLogin] = useState(
        !voicemailSettings.get('autoLogin'),
    );
    const [editPin, setEditPin] = useState(voicemailSettings.get('pin'));

    const handleUpdate = (updatedSettings: {
        key: string;
        autoLogin?: boolean;
        pin?: string;
    }) => {
        dispatch(updateVoicemailSettings(extensionKey, updatedSettings));
    };

    const toggleRequireLoginHandler = (value: boolean) => {
        handleUpdate({
            key: voicemailSettings.get('key'),
            autoLogin: !value,
        });
        setEditRequireLogin(value);
    };

    const updatePin = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = event.target.value;
        if (!isEmptyNullOrUndefined(newValue) && newValue.length < 10) {
            setEditPin(newValue);
        }
    };

    return (
        <>
            <SettingRow
                cta={
                    <Toggle
                        value={editRequireLogin}
                        onChange={toggleRequireLoginHandler}
                        text={i18next.t('settings.voicemail_login')}
                    />
                }
            >
                {i18next.t('settings.voicemail_login')}
            </SettingRow>

            <SettingSection>
                {i18next.t('settings.voicemail_pin')}
            </SettingSection>

            <div className="max-w-1/2">
                <InputField
                    value={editPin}
                    onChange={updatePin}
                    onBlur={() =>
                        handleUpdate({
                            key: voicemailSettings.get('key'),
                            pin: editPin,
                        })
                    }
                    autoFocus={true}
                />
            </div>
        </>
    );
};

export default EditVoicemailLogin;
